import React, { MouseEvent } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

type HeaderBarProps = {
  menuOpen: boolean;
  onOpenMenu: (event: MouseEvent<HTMLButtonElement>) => void;
};

const HeaderBar: React.FC<HeaderBarProps> = ({
 menuOpen,
 onOpenMenu,
}) => {
  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: 'white',
        color: 'black',
        boxShadow: 'none',
        borderBottom: '1px solid #e7e7e7',
      }}
    >
      <Toolbar>
        <img
          src="/logo.svg"
          alt="Logo"
          style={{ height: 32, backgroundColor: "#2362a2", borderRadius: "3px", padding: "5px" }}
        />
        <Typography variant="h6" component="div" sx={{
          margin: "0px 10px"
        }}>
          DSŘ - API
        </Typography>
        <NavLinks
          menuOpen={menuOpen}
          onOpenMenu={onOpenMenu}
        />
      </Toolbar>
    </AppBar>
  );
};

type NavLinksProps = {
  menuOpen: boolean;
  onOpenMenu: (event: MouseEvent<HTMLButtonElement>) => void;
};

const NavLinks: React.FC<NavLinksProps> = ({
 menuOpen,
 onOpenMenu,
}) => {
  return (
    <Box sx={{ ml: 'auto', display: 'flex', gap: 1 }}>

      <Button
        color="inherit"
        component="a"
        href="/"
      >
        Úvod
      </Button>
    <Button
        color="inherit"
        component="a"
        href="/autentizace"
    >
        Autentizace
    </Button>
      <Button
        color="inherit"
        component="a"
        href="/tutorial"
      >
        Průvodce
      </Button>


      <Button
        color="inherit"
        endIcon={<span style={{ fontSize: 10 }}>▾</span>}
        onMouseEnter={onOpenMenu}
        sx={{
          backgroundColor: menuOpen ? 'action.hover' : 'transparent',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        Specifikace
      </Button>
    </Box>
  );
};

export default HeaderBar;
